module.exports = __webpack_public_path__ + "img/ekdipa-logo.a69f6fba.png";